import { render } from "./TempoReal.vue?vue&type=template&id=baadec40"
import script from "./TempoReal.vue?vue&type=script&lang=js"
export * from "./TempoReal.vue?vue&type=script&lang=js"

import "./TempoReal.vue?vue&type=style&index=0&id=baadec40&lang=css"

import exportComponent from "F:\\Projetos 2024\\e-logDash\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__